export default __webpack_public_path__ + "static/media/neuromodular_form.bba3ad73.png";